import ApiResponse from "../models/ApiResponse";
import TestRequestProcessSubState from "../models/test-request/TestRequestProcessSubState";
import TestRequestProjectInfoRq from "../models/test-request/TestRequestProjectInfoRQ";
import TestRequestResponse from "../models/test-request/TestRequestResponse";
import Api from "./Api";

class TestRequestAproeApi {
  constructor(private api: Api) {}

  public changeSubState(
    testRequestId: string,
    newSubState: TestRequestProcessSubState,
  ): ApiResponse<TestRequestResponse> {
    return this.api.put(
      `/test-request/v2/testrequests/${testRequestId}/change-sub-state`,
      JSON.stringify(newSubState),
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
  }

  public updateProjectInformation(
    testRequestId: string,
    payload: TestRequestProjectInfoRq,
  ): ApiResponse<TestRequestResponse> {
    return this.api.put(`/test-request/v2/testrequests/${testRequestId}/project-info`, payload);
  }
}

export default TestRequestAproeApi;
